(() => {
  const CLAMPED_CLASS = 'richtext-see-more__content--clamped';
  const ANIMATING_CLASS = 'richtext-see-more__content--animating';

  const initSection = (section) => {
    const wrapper = section.querySelector('[data-richtext-see-more]');
    const content = section.querySelector('[data-richtext-see-more-content]');
    const button = section.querySelector('[data-richtext-see-more-button]');

    if (!wrapper || !content || !button) return;

    // Measure the true 3-line height at the current screen size/font by
    // briefly reading the clamped state's rendered height.
    const measureCollapsedHeight = () => {
      const wasClamped = content.classList.contains(CLAMPED_CLASS);
      if (!wasClamped) content.classList.add(CLAMPED_CLASS);
      const height = Math.ceil(content.getBoundingClientRect().height);
      if (!wasClamped) content.classList.remove(CLAMPED_CLASS);
      return height;
    };

    const isOverflowing = (collapsedHeight) =>
      content.scrollHeight > collapsedHeight + 1;

    const restCollapsed = () => {
      content.classList.remove(ANIMATING_CLASS);
      content.style.maxHeight = '';
      content.classList.add(CLAMPED_CLASS);
      button.textContent = 'See More';
      button.setAttribute('aria-expanded', 'false');
      wrapper.classList.remove('richtext-see-more--expanded');
    };

    const restExpanded = () => {
      content.classList.remove(ANIMATING_CLASS, CLAMPED_CLASS);
      content.style.maxHeight = '';
      button.textContent = 'See Less';
      button.setAttribute('aria-expanded', 'true');
      wrapper.classList.add('richtext-see-more--expanded');
    };

    const animateTo = (targetHeight, onDone) => {
      const startHeight = content.getBoundingClientRect().height;

      content.classList.remove(CLAMPED_CLASS);
      content.style.maxHeight = `${Math.ceil(startHeight)}px`;
      // Force reflow so the browser registers the starting height
      // before we change it, otherwise it won't animate.
      void content.offsetHeight;

      content.classList.add(ANIMATING_CLASS);
      content.style.maxHeight = `${targetHeight}px`;

      const handleEnd = (event) => {
        if (event.target !== content || event.propertyName !== 'max-height') return;
        content.removeEventListener('transitionend', handleEnd);
        onDone();
      };
      content.addEventListener('transitionend', handleEnd);
    };

    const expand = () => {
      animateTo(content.scrollHeight, restExpanded);
    };

    const collapse = () => {
      const collapsedHeight = measureCollapsedHeight();
      animateTo(collapsedHeight, restCollapsed);
    };

    const refresh = () => {
      const collapsedHeight = measureCollapsedHeight();
      const overflowing = isOverflowing(collapsedHeight);
      button.hidden = !overflowing;

      if (!overflowing) {
        content.classList.remove(CLAMPED_CLASS, ANIMATING_CLASS);
        content.style.maxHeight = '';
        return;
      }

      if (!wrapper.classList.contains('richtext-see-more--expanded')) {
        restCollapsed();
      }
    };

    button.addEventListener('click', () => {
      if (wrapper.classList.contains('richtext-see-more--expanded')) {
        collapse();
      } else {
        expand();
      }
    });

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(refresh, 150);
    });

    refresh();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refresh);
    }
  };

  const initAll = () => {
    document
      .querySelectorAll('[data-richtext-see-more-section] [data-richtext-see-more].richtext-see-more--enabled')
      .forEach((wrapper) => initSection(wrapper.closest('[data-richtext-see-more-section]')));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();